// 客户端插件集合导出
import Vue from 'vue'
// import VideoPlayer from 'vue-video-player/dist/ssr'
//  暂时不采用服务端渲染 轮播图 会存在一些坑
// import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import AOS from 'aos'

// const globalTools = {
//   install(app) {
//     // let winX = null
//     // let winY = null
//     // window.addEventListener('scroll', function () {
//     //   if (winX !== null && winY !== null) {
//     //     window.scrollTo(winX, winY)
//     //   }
//     // })
//     // app.prototype.tools = {
//     //   disableWindowScroll() {
//     //     winX = window.scrollX
//     //     winY = window.scrollY
//     //   },
//     //   enableWindowScroll() {
//     //     winX = null
//     //     winY = null
//     //   }
//     // }

//     app.prototype.$aos = AOS
//   }
// }

// Vue.use(VueAwesomeSwiper)

export default () => {
  // 视频插件
  // Vue.use(VideoPlayer)
  // 轮播插件
  Vue.use(VueAwesomeSwiper)

  // Vue.use(globalTools)
}
